
import { Vue } from "vue-class-component";

export default class CargoTruck extends Vue {}
